import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('droneCard');

    return {
        NOTE_GROUNDED: t('noteGrounded'),
        NOTE_HOLD: t('noteHold')
    };
};

export default useTranslation;
